import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import api from "../services/api";

const Checkout = () => {
  const { cartItems, totalPrice } = useCart();
  const [address, setAddress] = useState("");

  const handleCheckout = async () => {
    try {
      const { data } = await api.post("/api/orders/create", {
        items: cartItems.map((item) => ({
          productId: item._id,
          qty: item.qty,
        })),
        shippingAddress: address,
      });
      console.log("Order created:", data);
      alert("Order created successfully!");
    } catch (err) {
      console.error("Checkout error:", err);
      alert("Checkout failed");
    }
  };

  return (
    <div className="p-10 max-w-xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Checkout</h1>
      <textarea
        className="w-full border rounded-lg p-3 mb-4"
        placeholder="Enter your shipping address"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
      ></textarea>
      <div className="text-lg font-semibold mb-6">
        Total: ₹{totalPrice}
      </div>
      <button
        onClick={handleCheckout}
        className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
      >
        Pay Now
      </button>
    </div>
  );
};

export default Checkout;
